import { Component, Inject, OnInit} from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import * as fromModel from '../../services/models/';

@Component({
  selector: 'gp-snack-bar',
  templateUrl: './gp-snack-bar.component.html',
  styleUrls: ['./gp-snack-bar.component.scss'],
}) 
export class GPSnackBarComponent implements OnInit {
  
  icon;
  msg;
  styleClass;

  constructor(@Inject(MAT_SNACK_BAR_DATA) private data: any,
  private snackBarRef: MatSnackBarRef<GPSnackBarComponent>,) { }

  ngOnInit(): void {

    this.msg = this.data.message;
    switch(this.data.type){
      case fromModel.MSGTYPE.INFO:
        this.icon = "info";
        this.styleClass = "infoMsg";
        break;
      case fromModel.MSGTYPE.WARNING:
        this.icon = "warning";
        this.styleClass = "warningMsg";
      break;
      case fromModel.MSGTYPE.ERROR:
        this.icon = "error";
        this.styleClass = "errorMsg";
      break;
      case fromModel.MSGTYPE.SUCCESS:
        this.icon = "check_circle";
        this.styleClass = "successMsg";
      break;
    }
  }

  dismisss(){
    this.snackBarRef.dismiss();
  }
}